<parkour-content-unavailable-card
  description="We kunnen sommige gebeurtenissen nu niet weergeven, probeer later opnieuw."
>
  <!-- TODO: UX Copy verhaal aan JSON toevoegen --></parkour-content-unavailable-card
>
